<template>
<div>
    <div class="lds-ellipsis" v-show="status==states.LOADING" :class="loaderClass">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
    <div v-show="status==states.FAIL">
        <b-icon-exclamation-triangle variant="danger" class="text-exclaim"></b-icon-exclamation-triangle>
        <span class="text-danger">&nbsp; Server Error</span>
    </div>
</div>
</template>
<style scoped src="@/assets/loaders/styles.css"></style>
<style scoped>
.text-exclaim{
  size: 1.4rem;
}
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 60px;
}
.lds-ellipsis div {
  position: absolute;
  top: 23px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background:var(--app-primary-color);
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>
<script>
import {loadMixin} from "./index"
export default {
    mixins:[loadMixin],
    props:{
        loaderClass:String
    } 
};
</script>